// @flow
import axios from 'utils/axios';
const ApiService = {
  listAgencyBusinessPartners() {
    return axios.get('/agency_business_partners');
  },

  listProjectsByAgency(agencyId: String) {
    return axios.get(
      `/agency_business_partners/${agencyId}/listing_business_partners`
    );
  },

  autenticateUser(payload: any) {
    return axios.post('/users/sign_in', payload, { baseURL: '/' });
  },

  registerAgency(payload: any) {
    return axios.post('/users.json', payload, { baseURL: '/' });
  },

  getAgency(slug: String) {
    return axios.get(`/agency_business_partners/${slug}`, { baseURL: '/' });
  },

  getHomieConfig() {
    return axios.get('/utilities/homie_config.json', { baseURL: '/' });
  },

  getThirdPartyCompanyFees(agencyId: String) {
    return axios.get(`/third_party_company_fees/${agencyId}`);
  },

  sendRecoveryPasswordEmail(payload: any) {
    return axios.post('/users/password', payload, { baseURL: '/' });
  },

  getUser(userId: string) {
    return axios.get(`/users/${userId}`);
  },

  getIsEmailAlreadyTaken(id: string, payload: any) {
    return axios.get(`/users/${id}`, { params: payload });
  },

  getHomeById(id: string) {
    return axios.get(`/homes/${id}.json`);
  },

  getAgencyAdvisor(id: string) {
    return axios.get(`/advisors/${id}`);
  },

  sendFinancingUserConfirmationMail(payload: any) {
    return axios.post(`/financing_product/`, payload);
  }
};

export default ApiService;
